export default {
  /**
   * This function is copied and modified from viddsee_api's vs-profile.js
   * https://github.com/viddsee/viddsee_api/blob/0b508b14f8e376cca13e6ac890f31bce9226676c/assets/javascripts/vs-profile.js#L12
   *
   * Due to server side response inconsistency between unverification behaviour.
   * From the client side, I will need to clean up response first to keep the front end logic less complicated
   * @param {*} original
   */
  cleanUpResponse(original) {
    const result = {
      ...original,
    };
    if (result.is_email_verified === false) {
      // Case: User has both primary_email and unverified email.
      //       In this case, unverified_email take precedence,
      //       the existing primary email should be ignored and removed.
      if (result.unverified_email && result.primary_email) {
        result.primary_email = '';

      // Case: User has an unverified primary email.
      //       To keep the behaviour consistent, we will move primary_email to unverified_email
      //       The primary_email field should be ignored and removed.
      } else {
        result.unverified_email = result.primary_email;
        result.primary_email = '';
      }
      // Case: At this moment, unverified_email field is not cleared after verification.
      //       See: https://github.com/viddsee/viddsee_api/issues/115
    } else if (result.unverified_email === result.primary_email) {
      delete result.unverified_email;

    // Case: A unverified_email exist and it is not the same with primary_email.
    //       This imply that user email is not verified
    } else if (result.unverified_email) {
      // Do nothing
    }
    // At the end, remove this is_email_verified
    delete result.is_email_verified;
    // Also remove the deprecated field
    delete result.unconfirmed_email;

    return result;
  },
};



// WEBPACK FOOTER //
// ./src/utils/accountBlobNormaliser.js